import { useScrollIndicators } from "../../../../hooks/useScrollIndicators";
import { withTranslation } from "../../../../translation";
import styles from "./SelectedFacets.css";
import PropTypes from "prop-types";
import { useRef, useMemo } from "react";

export const SelectedFacets = ({
  selectedFacets,
  selectedFacetValues,
  changeMultiFacet,
  formatTranslation,
  clearAlwaysApply
}) => {
  if (!selectedFacetValues || selectedFacetValues.length === 0) {
    return null;
  }
  const containerRef = useRef(null);

  const { canScrollLeft, canScrollRight } = useScrollIndicators(containerRef);

  const onClick = facetValue => {
    const retrieveFacet = selectedFacets.find(
      selectedFacet => selectedFacet.id === facetValue.facetId
    );

    if (facetValue.id === "price") {
      clearAlwaysApply("currentprice");
    } else {
      changeMultiFacet([
        {
          facet: retrieveFacet,
          facetValue,
          isSelected: false
        }
      ]);
    }
  };

  const isScrollable = canScrollLeft || canScrollRight;
  const getMaskImage = (canScrollLeft, canScrollRight) => {
    const startColor = canScrollLeft ? "transparent" : "black";
    const endColor = canScrollRight ? "transparent" : "black";

    return `linear-gradient(to right, 
    ${startColor} 0%, 
    black 10%, 
    black 90%, 
    ${endColor} 100%)`;
  };

  const reverseSelectedFacetValues = useMemo(
    () => [...selectedFacetValues].reverse(),
    [selectedFacetValues]
  );

  return (
    <div
      ref={containerRef}
      className={styles.container}
      style={{
        maskImage: getMaskImage(canScrollLeft, canScrollRight),
        WebkitMaskImage: getMaskImage(canScrollLeft, canScrollRight),
        ...(isScrollable ? { marginTop: "4px" } : {})
      }}
    >
      {reverseSelectedFacetValues.map(facetValue => (
        <div key={facetValue.id} className={styles.facet}>
          <span className={styles.name}>{facetValue.name}</span>
          <button
            className={styles.close}
            onClick={() => onClick(facetValue)}
            aria-label={formatTranslation("accessibility_label_close")}
          />
        </div>
      ))}
    </div>
  );
};

SelectedFacets.propTypes = {
  facets: PropTypes.array.isRequired,
  selectedFacets: PropTypes.array.isRequired,
  selectedFacetValues: PropTypes.array.isRequired,
  changeMultiFacet: PropTypes.func.isRequired,
  formatTranslation: PropTypes.func.isRequired,
  resetPriceRange: PropTypes.func.isRequired,
  clearAlwaysApply: PropTypes.func.isRequired
};

export default withTranslation(SelectedFacets);
